import {SERVER_ERROR_CODES} from '../../constants';
import {BaseServerError} from './BaseServerError';

export class SaveError extends BaseServerError {
  constructor(message: string, type = 'SAVE', data?: any) {
    super((message as any) as string, SERVER_ERROR_CODES.SAVE, type, data);
  }
}
